import e from"react";import r from"prop-types";const t=({children:r})=>e.createElement("thead",{className:"bg-surface text-color-subtle"},r);t.propTypes={children:r.any};export{t as default};
